import { useState, useEffect } from 'react';
import { Button } from '../ui/button';
import { Badge } from '../ui/badge';
import { X } from 'lucide-react';
import PubSub from 'pubsub-js';

function FilterTag({ 
    FilterTags, 
    Loading,
    Roletype,
    dist_id,
    Rolename,
    wh_Id,
    df,
    dt,
    dashboardName,
    startDate,
    endDate,
    handeChangefiltertag,
    handlechangea
}) {
    const [filterTagList, setFilterTagList] = useState([]);
    const [filterMatchedTagList, setFilterMatchedTagList] = useState([]);
    const [loading, setLoading] = useState(Loading);
    const [resetDisabled, setResetDisabled] = useState(false);

    useEffect(() => {
        if (FilterTags != null && FilterTags != '' && FilterTags != undefined && FilterTags != "null") {
            bindFilteredTag(Roletype, dist_id, Rolename, wh_Id, df, dt, FilterTags);
        }
    }, []);

    useEffect(() => {
        if (FilterTags != null && FilterTags != '' && FilterTags != undefined && FilterTags != "null") {
            setFilterTagList([]);
            setResetDisabled(true);
            bindFilteredTag(Roletype, dist_id, Rolename, wh_Id, df, dt, FilterTags);
        }
    }, [FilterTags]);

    const bindFilteredTag = async (role, distributor_UserId, name, wholesalerid, datefrom, dateto, FilterJson) => {
        try {
            // PRESERVE EXACT API CALL - DO NOT CHANGE
            const requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'requestHeader': FilterJson },
                body: JSON.stringify({ role, distributor_UserId, name, wholesalerid, datefrom, dateto })
            };
            
            const response = await fetch(`/api/Filter/getFilterMatchingTag`, requestOptions);
            const text = await response.text();
            const apidata = text && JSON.parse(text);
            
            try {
                if (apidata.length > 0) {
                    setResetDisabled(false);
                    setFilterTagList(JSON.parse(FilterJson));
                    setFilterMatchedTagList(apidata);
                }
            } catch (error) {
                try {
                    setFilterTagList(FilterJson);
                    setFilterMatchedTagList(apidata);
                } catch (error) {
                }
            }
        } catch (error) {
        }
    };

    const handleRemoveTag = (e, nodename, nodevalue) => {
        try {
            let CreatedJson = '';
            try {
                let ExistJson = JSON.parse(localStorage.getItem('Advance_Filter'));
                CreatedJson = JSON.stringify(ExistJson);
                let ItemIndex = ExistJson[nodename].indexOf(nodevalue);
                
                if (ItemIndex > -1) {
                    ExistJson[nodename].splice(ItemIndex, 1);
                    if (ExistJson[nodename].length == 0) {
                        delete ExistJson[nodename];
                    }
                } else if (nodename == "PhZip" || nodename == "PrZip") {
                    let ItemIndex = ExistJson[nodename].indexOf(nodevalue.replace('-', ''));
                    ExistJson[nodename].splice(ItemIndex, 1);
                    if (ExistJson[nodename].length == 0) {
                        delete ExistJson[nodename];
                    }
                }
                
                try {
                    if (JSON.stringify(ExistJson) == "{}") {
                        localStorage.setItem('Advance_Filter', null);
                    } else {
                        localStorage.setItem('Advance_Filter', JSON.stringify(ExistJson));
                    }
                    let newDate = new Date();
                    localStorage.setItem('Filter_Last_Update_Time', newDate);
                    localStorage.setItem('Updated_AdFilter_Status', CreatedJson + newDate);
                    
                    // Check for specific PBM HD condition
                    const rxsInput = document.querySelector("input[name=rxsprocrss]:checked");
                    if (rxsInput && rxsInput.value != "totalpaid" && nodename == "PBM" && nodevalue == "HD") {
                        const LocalHDType = localStorage.getItem('Updated_HD_Type');
                        localStorage.setItem('Prev_HD_Type', LocalHDType);
                        localStorage.setItem('Updated_HD_Type', 'totalpaid');
                        let newDate = new Date();
                        localStorage.setItem('Filter_Last_Update_Time', newDate);
                        PubSub.publish('PBM', 'HD');
                    }
                    handlechangea(e);
                } catch (error) {
                }
            } catch (error) {
            }
        } catch (error) {
        }
    };

    const handleResetButton = (e) => {
        try {
            PubSub.publish('PBM', 'HD');
            setLoading(false);
            
            let CreatedJson = '';
            let ExistJson = JSON.parse(localStorage.getItem('Advance_Filter'));
            CreatedJson = JSON.stringify(ExistJson);
            localStorage.setItem('Advance_Filter', null);
            
            let newDate = new Date();
            localStorage.setItem('Filter_Last_Update_Time', newDate);
            localStorage.setItem('Updated_AdFilter_Status', CreatedJson + newDate);
            
            const LocalHDType = localStorage.getItem('Updated_HD_Type');
            localStorage.setItem('Prev_HD_Type', LocalHDType);
            localStorage.setItem('Updated_HD_Type', 'totalpaid');
            
            let newDate1 = new Date();
            localStorage.setItem('Filter_Last_Update_Time', newDate1);
            handlechangea(e);
        } catch (error) {
        }
    };

    const getTagTypeFullName = (stext) => {
        const tagNames = {
            'PBM': 'PCN',
            'PhBin': 'BIN',
            'DistributorName': 'Distributor Name',
            'PhCity': 'Pharmacy City',
            'PrCity': 'Prescriber City',
            'PhState': 'Pharmacy State',
            'PrState': 'Prescriber State',
            'PhZip': 'Pharmacy ZIP',
            'PrZip': 'Prescriber ZIP',
            'PharmacyName': 'Pharmacy Name',
            'GroupNumber': 'Group Number',
            'WholesalerName': 'Wholesaler Name',
            'DrugName': 'Drug Name',
            'Prescriber': 'Prescriber Name',
            'Override': 'Override',
            'PhGPrefix': 'Group Prefix',
            'Group Prefix': 'Group Prefix'
        };
        return tagNames[stext] || stext;
    };

    const renderFilterTags = () => {
        let icount = 0;
        Object.keys(filterTagList).forEach(() => {
            icount += 1;
        });

        if (icount > 0) {
            return (
                <div className='filtered_tag_selected tag-available'>
                    <div className="filtered_content">
                        <div className="filtered_adjust flex flex-wrap gap-2">
                            {Object.keys(filterTagList).map((key, index) => {
                                try {
                                    if (filterMatchedTagList.filter((d) => d["tableType"] == key).length > 0) {
                                        let KeyValue = filterMatchedTagList.filter(m1 => m1.tableType == key);
                                        return KeyValue.map((k1, ik) => {
                                            try {
                                                const isActive = k1.hasData == "True";
                                                return (
                                                    <Badge
                                                        key={`${key}-${k1.value}-${ik}`}
                                                        variant={isActive ? "default" : "secondary"}
                                                        className="gap-1 pr-1"
                                                    >
                                                        {getTagTypeFullName(key)}-{k1.value}
                                                        <button
                                                            onClick={(e) => handleRemoveTag(e, key, k1.value)}
                                                            className="ml-1 hover:bg-black/20 rounded-full p-0.5"
                                                        >
                                                            <X className="h-3 w-3" />
                                                        </button>
                                                    </Badge>
                                                );
                                            } catch (error) {
                                                return null;
                                            }
                                        });
                                    } else {
                                        return filterTagList[key].map((e1, i1) => (
                                            <Badge
                                                key={`${key}-${e1}-${i1}`}
                                                variant="secondary"
                                                className="gap-1 pr-1"
                                            >
                                                {getTagTypeFullName(e1)}-{e1}
                                                <button
                                                    onClick={(e) => handleRemoveTag(e, key, e1)}
                                                    className="ml-1 hover:bg-black/20 rounded-full p-0.5"
                                                >
                                                    <X className="h-3 w-3" />
                                                </button>
                                            </Badge>
                                        ));
                                    }
                                } catch (error) {
                                    return null;
                                }
                            })}
                        </div>
                        {filterTagList.propertyIsEnumerable?.length > 0 && filterMatchedTagList.length > 0 && (
                            <Button
                                disabled={resetDisabled}
                                onClick={handleResetButton}
                                className="reset-btn reset_filter_tag_button_event ml-2"
                                variant="outline"
                                size="sm"
                            >
                                Reset
                            </Button>
                        )}
                    </div>
                </div>
            );
        }

        // Fallback to localStorage if filterTagList is empty
        const LocalFilterJson = JSON.parse(localStorage.getItem('Advance_Filter'));
        if (LocalFilterJson != null && LocalFilterJson.propertyIsEnumerable?.length > 0) {
            return (
                <div className='filtered_tag_selected tag-available'>
                    <div className="filtered_content">
                        <div className="filtered_adjust flex flex-wrap gap-2">
                            {Object.keys(LocalFilterJson).map((key, index) => {
                                return LocalFilterJson[key].map((e1, i1) => (
                                    <Badge
                                        key={`${index}-${i1}`}
                                        variant="secondary"
                                        className="gap-1 pr-1"
                                    >
                                        {getTagTypeFullName(key)}-{e1}
                                        <button
                                            onClick={(e) => handleRemoveTag(e, key, e1)}
                                            className="ml-1 hover:bg-black/20 rounded-full p-0.5"
                                        >
                                            <X className="h-3 w-3" />
                                        </button>
                                    </Badge>
                                ));
                            })}
                        </div>
                        <Button
                            disabled={resetDisabled}
                            onClick={handleResetButton}
                            className="reset-btn reset_filter_tag_button_event ml-2"
                            variant="outline"
                            size="sm"
                        >
                            Reset
                        </Button>
                    </div>
                </div>
            );
        }

        return (
            <div className='filtered_tag_selected'>
                <div className="filtered_content">
                    <div className="filtered_adjust"></div>
                </div>
            </div>
        );
    };

    return renderFilterTags();
}

export default FilterTag;
